import {
  PaymentType,
  SchoolFundingType,
  SchoolSpaceType,
  SubscriptionPlanNameEnum,
} from "../../../generated/graphql";

export enum SchoolPaymentsEnum {
  subscriptionPlans = "subscriptionPlans",
  paymentsHistory = "paymentsHistory",
  createPayment = "createPayment",
  activatePayment = "activatePayment",
  deletePayment = "deletePayment",
}

export const CustomErrorMessagesMap = new Map<SchoolPaymentsEnum, string>([
  [SchoolPaymentsEnum.subscriptionPlans, "Помилка отримання планів підписки"],
  [SchoolPaymentsEnum.paymentsHistory, "Помилка отримання історії платежів"],
  [SchoolPaymentsEnum.createPayment, "Помилка створення платежу"],
  [SchoolPaymentsEnum.activatePayment, "Помилка активації платежу"],
  [SchoolPaymentsEnum.deletePayment, "Помилка видалення платежу"],
]);

export const NO_MANAGER_ERROR =
  "Failed to create subscription plan payment from admin panel You are not manager of this school";

export const GqlErrorMessagesMap = new Map<string, string>([
  [
    "You are not permitted for this action",
    "У вас немає прав на виконання цієї дії",
  ],
  [
    NO_MANAGER_ERROR,
    "Помилка створення платежу. Тільки менеджер школи може оформити підписку.",
  ],
]);

export const commonPaymentTypeMap = {
  [PaymentType.Manual]: "Безготівкова (ручна)",
  [PaymentType.Promotion]: "Маркетингова акція",
  [PaymentType.Technical]: "Технічний",
};

export const PersonalPaymentTypeMap = new Map<PaymentType, string>([
  [PaymentType.Fondy, "Fondy"],
  [PaymentType.Stripe, "Stripe"],
]);

export const CombinedPaymentTypeMap = new Map<PaymentType, string>([
  [PaymentType.Fondy, "Fondy"],
  [PaymentType.Stripe, "Stripe"],
  [PaymentType.Manual, "Безготівкова (ручна)"],
  [PaymentType.Promotion, "Маркетингова акція"],
  [PaymentType.Technical, "Технічний"],
]);

export const subscriptionPlansMonths = {
  [SubscriptionPlanNameEnum.TeacherOne]: {
    label: "(1 міс.)",
    durationInMonths: "1",
  },
  [SubscriptionPlanNameEnum.PupilOne]: {
    label: "(1 міс.)",
    durationInMonths: "1",
  },
  [SubscriptionPlanNameEnum.ParentOne]: {
    label: "(1 міс.)",
    durationInMonths: "1",
  },
  [SubscriptionPlanNameEnum.TeacherPlusOne]: {
    label: "(1 міс.)",
    durationInMonths: "1",
  },

  [SubscriptionPlanNameEnum.TeacherSix]: {
    label: "(6 міс.)",
    durationInMonths: "6",
  },
  [SubscriptionPlanNameEnum.PupilSix]: {
    label: "(6 міс.)",
    durationInMonths: "6",
  },
  [SubscriptionPlanNameEnum.ParentSix]: {
    label: "(6 міс.)",
    durationInMonths: "6",
  },
  [SubscriptionPlanNameEnum.TeacherPlusSix]: {
    label: "(6 міс.)",
    durationInMonths: "6",
  },

  [SubscriptionPlanNameEnum.TeacherTwelve]: {
    label: "(12 міс.)",
    durationInMonths: "12",
  },
  [SubscriptionPlanNameEnum.PupilTwelve]: {
    label: "(12 міс.)",
    durationInMonths: "12",
  },
  [SubscriptionPlanNameEnum.ParentTwelve]: {
    label: "(12 міс.)",
    durationInMonths: "12",
  },
  [SubscriptionPlanNameEnum.TeacherPlusTwelve]: {
    label: "(12 міс.)",
    durationInMonths: "12",
  },
};

export const schoolFundingType = {
  [SchoolFundingType.Private]: "Приватна",
  [SchoolFundingType.Public]: "Державна",
};

export const schoolSpaceType = {
  [SchoolSpaceType.School]: "Школа",
  [SchoolSpaceType.University]: "Університет",
};
